import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect, Route} from 'react-router-dom';
import Can from '../../common/guards/can';
import RedirectToLogin from '../../common/redirect-to-login';

import '../../sidenav/sidenav.css';
import './main-layout.css';
import IgniteNavigation from '../ignite-navigation.jsx';
import {USER_TYPE_ADMIN} from '../../../data/userTypes';

class AdminLayout extends Component {
  render() {
    const {
      component: RenderedComponent, permissions, subjectClass, action, loaded, isAdmin, viewConfig, ...rest
    } = this.props;

    return (
      <Route
        {...rest}
        render={(matchProps) => {
          if (!loaded) {
            return <div>Loading...</div>;
          }

          if (!isAdmin) {
            return <RedirectToLogin loginPath='/admin/login' requestedPath={window.location.pathname}/>;
          }

          return (
            <Can action={action} cannot={<Redirect to="/admin/my-profile"/>} subjectClass={subjectClass}>
              <div className="admin-layout">
                <div className="content-wrapper">
                  <IgniteNavigation type={USER_TYPE_ADMIN} igniteLogoLink="/admin/my-profile"/>

                  <RenderedComponent {...matchProps} area={USER_TYPE_ADMIN} permissions={permissions}/>
                </div>
              </div>
            </Can>
          );
        }}
      />
    );
  }
}

const mapStateToProps = state => ({
  viewConfig: state.viewConfig,
  currentUser: state.currentUser.user,
  userLoading: state.currentUser.fetching
});

export default connect(mapStateToProps)(AdminLayout);



// WEBPACK FOOTER //
// ./src/components/layout/admin-layout/index.jsx